/* __next_internal_client_entry_do_not_use__ ProductTileClickContext,useProductTileClickProps auto */ import React, { useContext } from "react";
export var ProductTileClickContext = /*#__PURE__*/ React.createContext({
    productLinkProps: {
        productUrl: ""
    },
    onProductClick: function() {}
});
export var useProductTileClickProps = function() {
    return useContext(ProductTileClickContext);
};
